<astrobin-nested-comments
  [addCommentLabel]="addCommentLabel"
  [allowModeration]="allowModeration"
  [allowSelfReply]="allowSelfReply"
  [autoStartTopLevelStrategy]="autoStartTopLevelStrategy"
  [category]="category"
  [contentType]="contentType"
  [highlightId]="highlightId"
  [info]="info"
  [noCommentsLabel]="noCommentsLabel"
  [objectId]="objectId"
  [showCloseButton]="true"
  [showReplyButton]="showReplyButton"
  [showTopLevelButton]="showTopLevelButton"
  [title]="title"
  [topLevelFormHeight]="topLevelFormHeight"
  [topLevelFormPlacement]="topLevelFormPlacement"
  (close)="handleClose()"
  (formDirtyChange)="isFormDirty = $event"
></astrobin-nested-comments>
